import { makeStyles } from '@material-ui/core/styles';
import { BOGLE_REGULAR, BOGLE_BOLD } from '../../constants/constant';
import { colors } from '../../theme/color-palette';

const {
	BLACK,
	PURPLE,
	BOLD_WHITE,
	PURPLE_ACTIVE,
	TOGGLE_ACTIVE,
	LIGHT_GRAY_SHADE,
} = colors;

export const useStyles = makeStyles((theme) => ({
	title: {
		float: 'left',
		fontFamily: 'Bogle-Regular !important',
		fontWeight: 'normal',
		color: theme.palette?.text?.main,
		fontSize: 24,
		marginLeft: 4,
		lineHeight: '64px',
		wordBreak: 'keep-all',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		[theme.breakpoints?.down('md')]: {
			fontSize: 20,
			marginLeft: 0,
		},
	},
	flexibleContainer: {
		border: '1px solid #dadce0',
		borderRadius: '8px',
		margin: '12px',
		marginRight: '32px',
		marginLeft: '32px',
	},

	headerInsights: {
		width: '100%',
		fontSize: '24px',
		fontWeight: 700,
		alignItems: 'center',
		display: 'column',
		padding: '24px 32px 0 32px',
		gap: '16px',
	},

	itemNameHeading: {
		marginTop: '12px 0px',
		padding: '2px 4px',
		fontSize: '24px',
		lineHeight: '36px',
		fontFamily: BOGLE_BOLD,
		letterSpacing: 'normal',
		textTransform: 'capitalize',
	},
	breadcrumbs: {
		padding: '0px 4px',
	},
	breadcrumb: {
		fontSize: '14px',
		color: colors.BREADCRUMB_INACTIVE,
		textDecoration: 'none',
		'&:hover': {
			cursor: 'pointer',
		},
	},

	breadcrumbActive: {
		fontSize: '14px',
		color: colors.BREADCRUMB_ACTIVE,
	},

	pageHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '16px',
	},
	channelFilter: {
		display: 'inline-flex',
		alignItems: 'center',
		backgroundColor: colors.LIGHT_GRAY_SHADE_1,
		padding: '4px 8px',
		borderRadius: '2px',
		gap: '4px',
		color: colors.DARK_GREY,
	},
	subTextStyles: {
		color: colors.DARK_GREY,
		fontSize: '12px',
		fontWeight: 400,
		lineHeight: '16px',
	},
	container: {
		boxSizing: 'border-box !important',
		display: 'flex',
		paddingRight: '16px',
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		justifyContent: 'space-between',
		'@media (max-width: 720px)': {
			justifyContent: 'space-between',
		},
	},
	menuPaper: {
		maxHeight: '390px !important',
		height: 'auto',
	},
	searchField: {
		borderRadius: 4,
		border: `1px solid var(--Full-Color-Palette-Gray-Gray-30, #D5D6D8)`,
		background: `var(--Base-No-Contrast, #FFF)`,
		display: 'flex !important',
		height: '32px !important',
		width: '100%',

		'& .MuiInputBase-input': {
			padding: '8px 16px 8px 0px',
			lineHeight: '20px !important',
			fontSize: '14px !important',
			fontWeight: 400,
			fontFamily: 'Bogle-regular !important',
		},
		'& .MuiInputBase-root': {
			paddingLeft: '16px !important',
		},
	},
	menu: {
		...selectStyleMenu,
	},
	menuItem: {
		display: 'flex !important',
		justifyContent: 'flex-start !important',
		paddingBottom: '8px !important',
		paddingTop: '6px !important',
		fontSize: '14px !important',
		fontFamily: `${BOGLE_REGULAR} !important`,
		lineHeight: '20px !important',
		fontWeight: '500 !important',
		padding: '10px 16px !important',
	},
	menuRow: {
		display: 'flex',
		padding: '16px 16px 6px 16px',
		width: '620px',
		justifyContent: 'flex-start',
		'@media (max-width: 720px)': {
			flexDirection: 'column-reverse',
			justifyContent: 'flex-start',
		},
	},
	menuFilters: {
		flex: 1,
		display: 'flex',
		width: '100%',
		justifyContent: 'flex-start',
		'@media (max-width: 720px)': {
			flexDirection: 'column',
			margin: '3px 0 3px 8px',
		},
	},
	formControl: {
		'@media (max-width: 1300px)': {
			width: '100% !important',
		},
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
		'&:hover': {
			background: LIGHT_GRAY_SHADE,
			height: '32px !important',
		},
	},
	formControlWidth: {
		width: '100%',
	},
	select: {
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontSize: '14px !important',
		height: '32px',
		'& .MuiSvgIcon-root': {
			color: BLACK,
		},
		'& .MuiSelect-select': {
			fontFamily: BOGLE_REGULAR,
			display: 'flex !important',
			alignItems: 'center',
		},
		'& .MuiInputBase-root': {
			'& .Mui-focused': {
				'& .MuiOutlinedInput-notchedOutline': {
					borderColor: PURPLE + ' !important',
				},
			},
		},
		'&:hover': {
			height: '32px !important',
		},
		'& .MuiPaper-root': {
			maxHeight: '390px !important',
		},
	},
	onFocus: {
		border: `${PURPLE_ACTIVE}`,
		backgroundColor: TOGGLE_ACTIVE,
		color: PURPLE_ACTIVE,
	},
	border: {
		position: 'relative',
		bottom: '-33px',
	},
}));

export const selectStyleMenu = {
	fontFamily: BOGLE_REGULAR,
	fontSize: '14px !important',
	'&& .Mui-selected': {
		backgroundColor: BOLD_WHITE,
	},
	'&& .Mui-checked': {
		color: PURPLE,
	},
};
